import { Action } from "redux";

export const WMS_3D_LAYER_LOADED = "WMS_3D_LAYER_LOADED";

export const wms3dLayerLoaded = (): Action => {
    return {
        type: WMS_3D_LAYER_LOADED,
    };
};
